import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

export interface PortalProps {
  children: React.ReactNode,
  containerId: string
}

/**
 * Generates a React Portal with the given children and contained in an
 * element with the given container id. This portal is special in that
 * it hides the main app content using aria-hidden=true, when the DialogPortal
 * is rendered
 *
 * @param props
 * @returns the react portal
 */
export const DialogPortal = ({ children, containerId }: PortalProps): JSX.Element => {
  const [container] = useState(() => {
    const el = document.createElement('div')
    el.id = containerId
    return el
  })

  useEffect(() => {
    document.body.append(container)

    const appRootId = 'medicare-my-root'
    document.getElementById(appRootId)?.setAttribute('aria-hidden', 'true')
    return () => {
      document.getElementById(appRootId)?.removeAttribute('aria-hidden')
      document.body.removeChild(container)
    }
  }, [container])

  return ReactDOM.createPortal(children, container)
}
